import { cn } from '@/lib/utils';
import Dot, { DotTone } from '@/components/ui/Dot.tsx';

interface ClientAcceptanceOutcomeRowProps
  extends React.HTMLAttributes<HTMLDivElement> {
  tone: DotTone;
  /** Wytłuszczony początek zdania — nazwa wyjścia z akceptacji. */
  term: string;
}

/** Pozycja listy „Po decyzji” — kolorowa kropka, wytłuszczony początek, reszta zdania. */
const ClientAcceptanceOutcomeRow = ({
  tone,
  term,
  children,
  className,
  ...props
}: ClientAcceptanceOutcomeRowProps) => (
  <div className={cn('flex items-start gap-[11px]', className)} {...props}>
    <Dot tone={tone} className="mt-1.5" />
    <span className="text-sm leading-normal text-neutral-800">
      <strong className="font-bold">{term}</strong> {children}
    </span>
  </div>
);

export default ClientAcceptanceOutcomeRow;
